/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourceDidCommMessage } from './ResourceDidCommMessage';

export const ListDidCommMessage: core.serialization.ObjectSchema<
    serializers.ListDidCommMessage.Raw,
    Truvity.ListDidCommMessage
> = core.serialization.object({
    items: core.serialization.list(ResourceDidCommMessage),
});

export declare namespace ListDidCommMessage {
    export interface Raw {
        items: ResourceDidCommMessage.Raw[];
    }
}
